module.exports = __webpack_public_path__ + "img/ch40.ce5d8c18.png";